import http from '@/plugins/http';
import reportError from '@/utils/reportError';

// When the request succeeds
const success = (response, onSuccessCallback) => {
  onSuccessCallback(response);
};

// When the request fails
const failed = (error, onFailureCallback) => {
  onFailureCallback(error);
};

export default (token, onFailureCallback, onSuccessCallback) => {
  http.get(`user/token/${token}/validate`)
    .then((response) => {
      success(response, onSuccessCallback);
    })
    .catch((error) => {
      reportError(error, 'error when trying to fetch reset password token');
      failed(error, onFailureCallback);
    });
};
